module.exports = __webpack_public_path__ + "static/media/ABfloors.c7d105a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/ABfloors.jpg
// module id = 467
// module chunks = 0